import { WordVoiceCommandIds, SelectionWhich } from '@augloop-types/voice';
var experimentalCommands = new Set([
    WordVoiceCommandIds.Paste,
    WordVoiceCommandIds.InsertTable,
    WordVoiceCommandIds.Redo
]);
// Temporary change for V1
var commandsWithSelection = new Set([
    WordVoiceCommandIds.Bold,
    WordVoiceCommandIds.Italics,
    WordVoiceCommandIds.Underline,
    WordVoiceCommandIds.Highlight,
    WordVoiceCommandIds.Select,
    WordVoiceCommandIds.Superscript,
    WordVoiceCommandIds.Subscript,
    WordVoiceCommandIds.StrikeThrough,
    WordVoiceCommandIds.RemoveBold,
    WordVoiceCommandIds.RemoveItalics,
    WordVoiceCommandIds.RemoveUnderline,
    WordVoiceCommandIds.RemoveHighlight,
    WordVoiceCommandIds.RemoveSuperscript,
    WordVoiceCommandIds.RemoveSubscript,
    WordVoiceCommandIds.RemoveStrikeThrough,
    WordVoiceCommandIds.Delete
]);
var enumKeysOfWordVoiceCommandIds = (Object.keys(WordVoiceCommandIds));
var selectionWhichSet = new Set(['previous', 'last']);
export var getValidCommandSet = function (enableExperimentalCommands) {
    var validCommandSet = new Set();
    for (var _i = 0, enumKeysOfWordVoiceCommandIds_1 = enumKeysOfWordVoiceCommandIds; _i < enumKeysOfWordVoiceCommandIds_1.length; _i++) {
        var key = enumKeysOfWordVoiceCommandIds_1[_i];
        // If experimentalCommands are allowed, then add that to valid Command set
        // Else, if only if command is not part of experimental commands, then add it to valid Command set
        if (enableExperimentalCommands || !experimentalCommands.has(WordVoiceCommandIds[key])) {
            validCommandSet.add(WordVoiceCommandIds[key]);
        }
    }
    return validCommandSet;
};
/** Returns true if this command is valid */
export var hasValidCommandValues = function (command) {
    // Check if this command supports commandSelection, and that commandSelection is NOT NSelection (We only support NSelection for delete as of writing this comment)
    if (commandsWithSelection.has(command.commandId)) {
        return !(command.selection && isInvalidSelection(command.selection, command.commandId));
    }
    return true;
};
/** Returns true if selection is valid. We do don't support Next in selection, and NSelection greater than 1 */
var isInvalidSelection = function (selection, commandId) {
    // Invalid if selectionWhich is 'next' or N in isNSelection is greater than 1 and isn't Delete command. (We only support NSelection for delete as of writing this comment)
    return (selection.which === SelectionWhich.Next || (commandId !== WordVoiceCommandIds.Delete && isNSelection(selection)));
};
/** Returns true if 'which' is previous or last and selectionNumber is greater than 1
 * We don't support NSelection (Eg: bold last 3 words). But AL returns intent bold.
 * So if input is of type NSelection, we ignore it */
var isNSelection = function (selection) {
    var selectionNumber = selection.count || 1;
    return !!(selection.which && selectionWhichSet.has(selection.which.toLocaleLowerCase()) && selectionNumber > 1);
};
/** Takes command and alters and returns the same.
 * This is a temporary fixe for results from AL */
export var alterCommandValue = function (command) {
    // If command is InsertComment, then keep only command text for floatie, and remove actual comment
    if (command.commandId === WordVoiceCommandIds.InsertComment) {
        var matchedPhrases = command.sourceText.match(/(.*comment[s]?)/);
        if (matchedPhrases) {
            command.sourceText = matchedPhrases[1]; // TODO: 4180157 - command.commandValue?.comment?.commentCommand;
        }
    }
    return command;
};
//# sourceMappingURL=validCommandUtil.js.map